import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon/arrow-back-1-1</title><path d="M12.7 4.5v3.18a.49.49 0 01-.54.44H7.4v2.74a.3.3 0 01-.5.22L.19 6.39a.35.35 0 01-.02-.61l6.74-4.69a.29.29 0 01.5.22v2.74h4.72c.26-.04.51.14.56.4v.04" fill="#BCD1F7" fillRule="evenodd" /></svg>);